<template>
  <div class="promo-page">
    <div class="info-card">
      <img
        class="info-card-image"
        height="50%"
        :src="`${siteHref}/img/error/${image}`"
        width="50%">
      <div class="info-card-text">
        <div class="info-card-text-title">
          {{ $t(`Errors.Promo.${translateKey}.Title`) }}?
        </div>
        <div class="info-card-text-label">
          <div>
            {{ $t(`Errors.Promo.${translateKey}.Label.0`) }}
          </div>
          <div>
            {{ $t(`Errors.Promo.${translateKey}.Label.1`) }}
          </div>
        </div>
        <div
          class="info-card-text-btns">
          <sButton
            class="info-card-text-btn"
            @click="sendRequest">
            {{ $t('Common.SubmitApplication') }}
          </sButton>
        </div>
      </div>
    </div>
    <ManagerCard class="mt-auto"/>
  </div>
</template>
<script>
import ManagerCard from 'components/common/blocks/ManagerCard.vue'
import SmarttenderApi from '@/api/smarttenderApi'

const api = new SmarttenderApi()

export default {
  name: 'promoPage',
  data() {
    return {
      siteHref: window.config?.BaseUrl,
    }
  },
  methods: {
    sendRequest() {
      api.purchasiesRequest( Number(this.$route.params.id) )
        .then(res => {
          if (res) {
            this.$Modal.info({
              title: this.$t('Common.ApplicationSubmitted'),
              content: this.$t('Common.ExpectCallManager'),
              okText: this.$t('Common.ThankYou'),
              duration: 10,
            })
          } else {
            this.$notice.info({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Errors.STHWrong'),
              duration: 10
            })
          }
        })
        .catch(res => this.$log_error(res))
    }
  },
  computed: {
    image() {
      if (this.typePage === 'planning') {
        return 'NoAccessPlan.svg'
      }
      return 'NoAccessPurchase.svg'
    },
    manager() {
      return this.$store.getters.getPersonalManagerContacts || this.$store.getters.getSupport
    },
    translateKey() {
      return this.typePage.charAt(0).toUpperCase() + this.typePage.slice(1)
    }
  },
  props: {
    typePage: {
      type: String,
      validator: function (value) {
        return ['planning', 'purchassing'].indexOf(value) !== -1
      },
      default: 'planning',
    }
  },
  created() {
    this.$store.dispatch('personalManagerContacts')
  },
  components: {
    ManagerCard
  }
}
</script>
<style lang="scss" scoped>
.promo-page {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  align-items: center;
  background: var(--color-main-green);

  & .info-card {
    display: flex;
    margin-top: 70px;
    width: 100%;
    justify-content: center;
    @media (max-width:935px) {
      margin-top: 0px;
    }
    &-image {
      width: 30%;
      max-width: 550px;
      max-height: 360px;
      margin: auto;
      //padding: 0px 90px 0 170px;
      @media (max-width: 935px) {
        position: absolute;
        z-index: 0;
        opacity: 0.1;
        width: 100%;
        padding: 0px;
        justify-content: center;
      }
    }
    &-text {
      padding-left: 45px;
      padding-top: 25px;
      width: 50%;
      text-align: left;
      padding-right: 130px;
      z-index: 2;
      @media (max-width: 935px) {
        width: 100%;
        padding: 0 20px;
        justify-content: center;
      }
      &-title {
        font-weight: 600;
        font-size: 24px;
        line-height: 28px;
        @media (max-width:935px) {
          margin-left: 0;
          text-align: center;
        }
      }
      &-label {
        padding-top: 35px;
        font-size: 18px;
        line-height: 25px;
      }
      &-btns {
        margin-top: 40px;
        display: flex;
        @media (max-width:935px) {
          display: grid;
          row-gap: 20px;
          max-width: 100%;
        }
      }
      &-btn {
        @media (max-width:935px) {
          margin-left: auto !important;
          margin-right: auto !important;
          max-width: 100%;
          width: 300px;
        }
      }
    }
  }
}

</style>
